import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';

export const ControlsSchema = z.object({
  buildingAutomationSystem: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});

export type Controls = z.infer<typeof ControlsSchema>;
